import $ from 'jquery';
import { resizeScroll, scrollTo } from '../core/ScrollService.js';
import Utils from '../utils/Utils.js';
import { initFaqMobile } from '../features/faqMobile.js';
import { initTextareas } from '../features/textareas.js';

export function initFaqCategoriesNav() {
    if (!document.querySelector('.faqCategories')) return;
    document.querySelectorAll('.faqCategories a').forEach((link) => {
        link.addEventListener('click', (e) => {
            e.preventDefault();
            const category = link.getAttribute('data-category');
            const elt = document.querySelector('.faqCategory[data-category="' + category + '"]');
            scrollTo(elt, -70);
        });
    });
    initFaqMobile();
}

export function initFooterMobileMenu() {
    if (!document.querySelectorAll('.footer_navMain .menu-item-has-children').length) {
        return;
    }
    document.querySelectorAll('.footer_navMain .menu-item-has-children').forEach((li) => {
        const link = li.querySelector('a');
        const submenu = li.querySelector('.sub-menu');
        link.addEventListener('click', (e) => {
            e.preventDefault();
            $(submenu).slideToggle();

            if (link.classList.contains('opened')) {
                link.classList.remove('opened');
            } else {
                link.classList.add('opened');
            }
        });
    });
}

export function initHubspotFormScroll() {
    window.addEventListener('message', (event) => {
        if (event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormSubmit') {
            setTimeout(() => {
                resizeScroll();
                scrollTo('.submitted-message', -180);
            }, 500);
        }
    });
}

export function initContactPageForms() {
    if (!document.body.classList.contains('page-template-tpl-contact')) return;
    if (document.querySelectorAll('.contact-control').length <= 1) return;
    document.querySelectorAll('.contact-control input').forEach((radio) => {
        radio.addEventListener('change', () => {
            document.querySelector('.formContainer.active').classList.remove('active');
            document.querySelector('.formContainer--' + radio.value).classList.add('active');
            initTextareas();
        });
    });
}
